import { createFileRoute, redirect } from '@tanstack/react-router'
import { WarehousesScreen } from '@/features/inventory-warehouses/warehouses-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/inventory/warehouses')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'warehouse.view')) throw redirect({ to: '/' })
  },
  component: WarehousesScreen,
})
